var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message",class:( _obj = {}, _obj[_vm.type] = _vm.type != null, _obj )},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }